import * as Yup from "yup";
import isEqual from "lodash.isequal";

import type { CustomAlertForm } from "./types";

// A regex for UUID v1-v5
const uuidRegex =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const customAlertSchema = Yup.object<CustomAlertForm>({
  deliveryMethod: Yup.string()
    .required("Please select a delivery method.")
    .notOneOf(["unknown"], "Please select a delivery method."),
  model: Yup.string(),
  // If both values are provided, startAmount cannot exceed endAmount.
  greaterThanAmount: Yup.number()
    .nullable()
    .test(
      "greater-than-amount-max",
      "Amount cannot be above the upper limit.",
      (value, context) =>
        context.parent.lessThanAmount === null ||
        value === null ||
        value === undefined ||
        +value < +context.parent.lessThanAmount,
    ),
  lessThanAmount: Yup.number()
    .nullable()
    .test(
      "less-than-amount-max",
      "Amount cannot be below the lower limit.",
      (value, context) =>
        context.parent.greaterThanAmount === null ||
        value === null ||
        value === undefined ||
        +value > +context.parent.greaterThanAmount,
    ),
  // Similarly, for balances.
  greaterThanBalance: Yup.number()
    .nullable()
    .test(
      "start-balance-max",
      "Balance cannot be greater than upper limit.",
      (value, context) =>
        context.parent.lessThanBalance === null ||
        value === null ||
        value === undefined ||
        +value <= +context.parent.lessThanBalance,
    ),
  lessThanBalance: Yup.number()
    .nullable()
    .test(
      "less-than-amount-max",
      "Balance cannot be below the lower limit.",
      (value, context) =>
        context.parent.greaterThanBalance === null ||
        value === null ||
        value === undefined ||
        +value > +context.parent.greaterThanBalance,
    ),
  description: Yup.string(),
  accounts: Yup.array()
    .of(Yup.string().matches(uuidRegex, "Please select a valid account."))
    .nullable()
    .test(
      "is-non-empty-or-null",
      "Please select a valid account.",
      (value) => value === null || !isEqual(value, []),
    ),
});
